<template>
  <div class="outpatientData" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-radio-group v-model="type" @input="typeChange">
          <el-radio-button class="header_left_radio" label="1">门诊</el-radio-button>
          <el-radio-button class="header_left_radio" label="2">网诊</el-radio-button>
        </el-radio-group>
      </div>
      <div class="header_right">
        <DateSelect v-model="date" @change="dateChange"></DateSelect>
      </div>
    </div>

    <!-- 基础数据 -->
    <div class="card basic">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">{{ type === '1' ? '门诊' : '网诊' }}基础数据</div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
      </div>

      <div class="basic_status_list" :style="`grid-template-columns: ${statusMap.gridColumns}`">
        <template v-for="statusItem in statusMap.list">
          <div v-if="statusItem.type !== 'line'" :class="{ status_list_item: true, active: statusItem.id === statusActive }" @click="statusOn(statusItem.id)">
            <div class="status_title">{{ statusItem.name }}</div>
            <div class="status_info">
              <div class="status_info_left">
                <div class="status_info_title">人数(人)</div>
                <div class="status_info_num">{{ statusItem.registrationNum }}</div>
              </div>
              <div v-if="!statusItem.hideRight" class="status_info_line"></div>
              <div v-if="!statusItem.hideRight" class="status_info_right">
                <div class="status_info_title">费用(元)</div>
                <div class="status_info_num">{{ statusItem.price }}</div>
              </div>
            </div>
            <div v-if="![0, '0', '', null, undefined].includes(statusItem.waitPrice) && statusItem.id != 2" class="status_info_tips">含<span class="status_info_tips_num">{{ statusItem.waitPrice }}</span>待收</div>
          </div>

          <div v-if="statusItem.type === 'line'" class="status_list_line"></div>
        </template>
      </div>

      <div class="basic_table_header" v-if="countStatusStatistics && type == 1">
        <div class="basic_table_count" v-if="statusActive != 7">
          普通门诊订单数<span class="basic_table_count_num">{{ countStatusStatistics.outpatientClinicOrderCount || 0 }}</span>单，
          快捷开方订单数<span class="basic_table_count_num">{{ countStatusStatistics.fastOrderCount || 0 }}</span>单
        </div>
        <div class="basic_table_count" v-else>
          零售开方订单数<span class="basic_table_count_num">{{ countStatusStatistics.saleOrderCount || 0 }}</span>单，
          续方订单数<span class="basic_table_count_num">{{ computedCalculate(countStatusStatistics.picOrderCount,'+',countStatusStatistics.dicOrderCount)  || 0 }}</span>单，
          转方开方订单数<span class="basic_table_count_num">{{ countStatusStatistics.transferOrderCount || 0 }}</span>单，
          转方挂号开方订单数<span class="basic_table_count_num">{{ countStatusStatistics. transferRegOrderCount || 0 }}</span>单
        </div>
      </div>

      <div class="basic_table_section">
        <el-table class="custom_table" :data="basicMap.list">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="patientName" label="患者" min-width="100"></el-table-column>
          <el-table-column prop="sex" label="性别" min-width="60">
            <template slot-scope="scope">
              <div>{{ computedDictText(scope.row.sex, sexDict) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
            <template slot-scope="scope">
              <div>{{ scope.row.age}}岁{{ scope.row.ageMth }}月</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号码" min-width="140"></el-table-column>
          <el-table-column prop="doctorVisit" label="初/复诊" min-width="80">
            <template slot-scope="scope">
              <div>{{ computedDictText(scope.row.doctorVisit, doctorVisitList) }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="orderType" label="门诊类型" min-width="110">
            <template slot-scope="scope">
              <div>{{ type == 1 ? ( statusActive == '7' && ['12','13'].includes(scope.row.orderType) ? '自助续方' : computedDictText(scope.row.registeredType, outpatientTypeList)) : '网诊' }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="ctAmount" label="实收费用" min-width="120">
            <template slot-scope="scope">
              <div class="basic_table_price">
                <span class="basic_table_price_text">￥{{scope.row.totalAmount}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ctAmount" label="原价费用" min-width="120">
            <template slot-scope="scope">
              <div class="basic_table_price">
                <span class="basic_table_price_text">￥{{scope.row.originalAmount}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ctAmount" label="优惠券" min-width="120">
            <template slot-scope="scope">
              <div class="basic_table_price">
                <span class="basic_table_price_text">￥{{scope.row.couponDiscountAmount}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="ctAmount" label="折扣" min-width="120">
            <template slot-scope="scope">
              <div class="basic_table_price">
                <span class="basic_table_price_text">￥{{ computedCalculate(scope.row.bargainDiscountAmount,'+',scope.row.vipCardDiscountAmount)}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="预约时间" min-width="200">
            <template slot-scope="scope">
              <div>{{ type == 2 ? scope.row.weChatPayDate : computedAppointmentTime(scope.row) }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="type == 1" prop="registeredCode" label="号数" min-width="100"></el-table-column>
          <el-table-column prop="finishTime" label="完诊时间" min-width="200"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" min-width="100">
            <template slot-scope="scope">
              <div class="basic_table_center">
                <div class="basic_table_tag" :style="{color:statusObj[scope.row.status].color,background:statusObj[scope.row.status].bgColor}">{{statusObj[scope.row.status].label}}</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="basic_table_pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="basicMap.pageNum"
          :page-size="basicMap.pageSize"
          :total="basicMap.total"
          @current-change="basicTablePageNoChange">
        </el-pagination>
      </div>
    </div>

    <div class="analyze">
      <div class="card analyze_info">
        <div class="card_header">
          <div class="card_header_left">
            <div class="card_header_title">{{ type === '1' ? '门诊' : '网诊' }}分析</div>
            <div class="card_header_date">{{ date | dateFilter }}</div>
          </div>
        </div>
        <div class="metric_list">
          <div v-for="(metricRow, metricRowIndex) in metricList" :key="metricRowIndex" class="metric_row">
            <div v-for="(metric, metricIndex) in metricRow" :key="metricIndex" class="metric_item">
              <div class="metric_header">
                <div class="metric_label">{{ metric.label }}</div>
                <div class="metric_icon">
                  <img class="metric_icon_img" :src="imgArr[metric.icon]"></img>
                </div>
              </div>
              <div class="metric_count">
                <div class="metric_count_num">{{ metric.num }}</div>
                <div class="metric_count_unit">{{ metric.unit }}</div>
              </div>
              <div v-if="metric.tipsLabel" class="metric_tips">
                <div class="metric_tips_label" >{{ metric.tipsLabel }}</div>
                <div class="metric_tips_value" v-if="metric.tipsValueKey == 'avgDayOrderDrugPrice'">{{ metric.tipsValue }}元/天</div>
                <div class="metric_tips_value" v-else>{{ metric.tipsValue }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card diagnosis_ranking">
        <div class="card_header">
          <div class="card_header_left">
            <div class="card_header_icon">
              <img class="card_header_icon_img" :src="imgArr.doctorData_ranking" alt="">
            </div>
            <div class="card_header_title">病种排名</div>
            <div class="card_header_date">{{ date | dateFilter }}</div>
          </div>
          <div class="card_header_right"></div>
        </div>
        <div class="ranking_list">
          <el-table class="ranking_table" :data="diagnosisRankingList" height="266">
            <el-table-column type="index" label="排名" align="center" width="80">
              <template slot-scope="scope">
                <div :class="{ ranking_table_index: true, ranking_table_index_1: scope.$index + 1 === 1, ranking_table_index_2: scope.$index + 1 === 2, ranking_table_index_3: scope.$index + 1 === 3 }">{{ scope.$index + 1 }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="诊断名称" min-width="250" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="ranking_table_name">{{ scope.row.diagnosis }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="患者数" align="center" min-width="100">
              <template slot-scope="scope">
                <div>{{ scope.row.count }}人</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import DateSelect from './components/DateSelect.vue'
  import { queryOpdStatusStatistics,queryOptStatusStatisticsBaseData,opdDataStatistics,queryOpdDiagnosisRank} from '@/api/doctorDataAnalysis'
  import { Utils } from '@/utils/utils'
  import { sexDict,doctorVisitList,outpatientTypeList } from '@/utils/const'
  import { dictText,isNull } from '@/utils/validateBase'
  import { imgArr } from '@/assets/images/img'
  
  export default {
    name: 'outpatientData',
    components: { DateSelect },
    filters: {
      dateFilter (value) {
        if (Array.isArray(value) && value.length === 2) {
          if (value[0] === value[1]) {
            const today = new Date().Format('yyyy-MM-dd')
            if (value[0] === today) {
              return `今天${new Date(today).Format('MM.dd')}`
            }

            let tomorrowDay = new Date()
            tomorrowDay.setDate(tomorrowDay.getDate() + 1)
            tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
            if (value[0] === tomorrowDay) {
              return `明天${new Date(tomorrowDay).Format('MM.dd')}`
            }

            let afterTomorrow = new Date()
            afterTomorrow.setDate(afterTomorrow.getDate() + 2)
            afterTomorrow = afterTomorrow.Format('yyyy-MM-dd')
            if (value[0] === afterTomorrow) {
              return `后天${new Date(afterTomorrow).Format('MM.dd')}`
            }

            let yesterdayDay = new Date()
            yesterdayDay.setDate(yesterdayDay.getDate() - 1)
            yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
            if (value[0] === yesterdayDay) {
              return `昨天${new Date(yesterdayDay).Format('MM.dd')}`
            }

            let format = new Date(value[0]).Format('yyyy') === new Date().Format('yyyy') ? 'MM.dd' : 'yyyy.MM.dd'
            return `${new Date(value[0]).Format(format)}`
          } else {
            return `${new Date(value[0]).Format('yyyy.MM.dd')} - ${new Date(value[1]).Format('yyyy.MM.dd')}`
          }
        }
        return ''
      }
    },
    props: {
      doctorId: {
        type: [Number, String],
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        reqNum: 0,
        imgArr: imgArr,
        type: '1',
        date: [new Date().Format('yyyy-MM-dd'), new Date().Format('yyyy-MM-dd')],
        statusActive: 1,
        basicMap: {
          list: [],
          pageNum: 1,
          pageSize: 10,
          total: 0
        },
        diagnosisRankingList: [],
        sexDict:sexDict,
        doctorVisitList:doctorVisitList,
        outpatientTypeList:outpatientTypeList,
        countStatusStatistics:{},
        statusObj: {
          2:{label:'待收',color:'#FE8F1F',bgColor:'#FFF0E1'},
          3:{label:'已收',color:'#29C01B',bgColor:'#E2F8E0'},
          4:{label:'已退',color:'#87919B',bgColor:'#F7F8F9'},
          5:{label:'关闭',color:'#87919B',bgColor:'#F7F8F9'},
          6:{label:'未开方',color:'#87919B',bgColor:'#F7F8F9'},
        }
      }
    },
    computed: {
      computedAppointmentTime(){
        return function(row){
          return isNull(row.appointmentStartDateTime) ? '' : `${this.$moment(row.appointmentStartDateTime).format('yyyy-MM-DD')} ${this.$moment(row.appointmentStartDateTime).format('HH:mm')}-${this.$moment(row.appointmentEndDateTime).format('HH:mm')}`
        }
      },
      computedDictText(){
        return function(val,list){
          return isNull(val) ? '' : dictText(val,list)
        }
      },
      computedCalculate(){
        return function(a, operate, b, bit){
          return isNull(a) || isNull(operate) || isNull(b) ? '' : this.$bigNumber(a, operate, b)
        }
      },
      statusMap () {
        let gridColumns = ''
        let list = []
        
        gridColumns = '1fr auto 1fr 1fr 1fr 1fr 1fr auto 1fr'
        list = [
          {
            id: 1,
            type: 'diagnosedStatusStatistics',
            name: this.type === '1' ? '总门诊量' : '总网诊量',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: -1,
            type: 'line'
          },
          {
            id: 2,
            type: 'notPayStatusStatistics',
            name: '待收',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: 3,
            type: 'payStatusStatistics',
            name: '已收',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: 6,
            type: 'notPrescribedStatusStatistics',
            name: '仅看诊',
            registrationNum: 0,
            hideRight: true,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: 4,
            type: 'refundStatusStatistics',
            name: '已退',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: 5,
            type: 'closeStatusStatistics',
            name: '关闭',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          },
          {
            id: -2,
            type: 'line'
          },
          {
            id: 7,
            type: 'otherStatusStatistics',
            name: '其他开单',
            registrationNum: 0,
            price: 0,
            waitPrice: 0,
            countStatusStatistics:{},
          }
        ]
        
        return {
          gridColumns: gridColumns,
          list: list
        }
      },
      metricList () {
        
        return this.type == 1 ? [
          [
            {
              label: '次均门诊人数',
              icon: 'doctorData_people',
              num: 0,
              unit: '人',
              tipsLabel: '坐诊次数',
              tipsValue: '0',
              numKey:'avgOpdNumber',
              tipsValueKey:'opdCount'
            },
            {
              label: '当天预约复诊人数',
              icon: 'doctorData_followUpVisit',
              num: 0,
              unit: '人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'doctorVisitNumber',
              tipsValueKey:''
            }
          ],
          [
            {
              label: '人均客单价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderPrice',
              tipsValueKey:''
            },
            {
              label: '中药处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '人均服用价',
              tipsValue: '20元/天',
              numKey:'avgOrderDrugPrice',
              tipsValueKey:'avgDayOrderDrugPrice'
            },
            {
              label: '理疗处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderPhysioPrice',
              tipsValueKey:''
            },
            {
              label: '中成药处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderChinesePatentDrugPrice',
              tipsValueKey:''
            }
          ]
        ] : [
          [
            {
              label: '人均客单价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderPrice',
              tipsValueKey:''
            },
            {
              label: '中药处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '人均服用价',
              tipsValue: '20元/天',
              numKey:'avgOrderDrugPrice',
              tipsValueKey:'avgDayOrderDrugPrice'
            },
            {
              label: '理疗处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderPhysioPrice',
              tipsValueKey:''
            },
            {
              label: '中成药处方均价',
              icon: 'doctorData_money',
              num: 0,
              unit: '元/人',
              tipsLabel: '',
              tipsValue: '',
              numKey:'avgOrderChinesePatentDrugPrice',
              tipsValueKey:''
            }
          ]
        ]
      }
    },
    created(){
      this.getOpdStatusStatistics()
      this.getList()
      this.getOpdDataStatistics()
      this.getOpdDiagnosisRank()
    },
    methods: {
      afterRes () {
        this.reqNum--;
        if (this.reqNum <= 0) {
          this.loading = false
          this.reqNum = 0;
        }
      },
      typeChange(){
        this.getOpdStatusStatistics()
        this.getList()
        this.getOpdDataStatistics()
        this.getOpdDiagnosisRank()
      },  
      dateChange(date){
        this.date = date
        this.getOpdStatusStatistics()
        this.getList()
        this.getOpdDataStatistics()
        this.getOpdDiagnosisRank()
      },
      statusOn (id) {
        if (id && this.statusActive !== id) {
          this.statusActive = id
          this.basicMap.pageNum = 1
          this.getOpdStatusStatistics()
          this.getList()
        }
      },
      async getOpdStatusStatistics(){
        let params = {
          deptId: this.$session.get('deptId'),
          doctorId: this.doctorId,
          startTime: Utils.timeFormat(Number(Utils.startOfDay(this.date[0])), 'yyyy-MM-DD HH:mm:ss'),
          endTime: Utils.timeFormat(Number(Utils.endOfDay(this.date[1])), 'yyyy-MM-DD HH:mm:ss'),
          orderType: this.type
        }
        this.loading = true
        this.reqNum++
        let {code ,data} = await queryOpdStatusStatistics(params)
        this.afterRes()
        if(code==200 && data){
          for (const key in data) {
            this.statusMap.list.forEach(v=>{
              if(key == v.type){
                v.registrationNum = data[key].count
                v.price = data[key].amount
                v.waitPrice = data[key].stayPayAmount
                v.countStatusStatistics = data[key].countStatusStatistics
              }
            })
          }
          this.countStatusStatistics = this.statusMap.list.find(v=>{return v.id == this.statusActive }).countStatusStatistics
          this.$forceUpdate()
        }
      },
      async getList(){
        let params = {
          deptId: this.$session.get('deptId'),
          doctorId: this.doctorId,
          startTime: Utils.timeFormat(Number(Utils.startOfDay(this.date[0])), 'yyyy-MM-DD HH:mm:ss'),
          endTime: Utils.timeFormat(Number(Utils.endOfDay(this.date[1])), 'yyyy-MM-DD HH:mm:ss'),
          orderType: this.type,
          pageNum: this.basicMap.pageNum,
          pageSize: this.basicMap.pageSize,
          status: this.statusActive
        }
        this.loading = true
        this.reqNum++
        let {code,rows,total} = await queryOptStatusStatisticsBaseData(params)
        this.afterRes()
        if(code==200){
          this.basicMap.list = rows || [],
          this.basicMap.total = total || 0
        }
      },
      async getOpdDataStatistics(){
        let params = {
          deptId: this.$session.get('deptId'),
          doctorId: this.doctorId,
          startTime: Utils.timeFormat(Number(Utils.startOfDay(this.date[0])), 'yyyy-MM-DD HH:mm:ss'),
          endTime: Utils.timeFormat(Number(Utils.endOfDay(this.date[1])), 'yyyy-MM-DD HH:mm:ss'),
          orderType: this.type,
        }
        this.loading = true
        this.reqNum++
        let {code,data} = await opdDataStatistics(params)
        this.afterRes()
        if(code==200 && data){
          for (const key in data) {
            this.metricList.forEach(v1=>{
              v1.forEach(v2=>{
                if(v2.numKey == key){ v2.num = data[key]}
                if(v2.tipsValueKey == key) { v2.tipsValue = data[key]}
              })
            })
          }
        }
      },
      async getOpdDiagnosisRank(){
         let params = {
          deptId: this.$session.get('deptId'),
          doctorId: this.doctorId,
          startTime: Utils.timeFormat(Number(Utils.startOfDay(this.date[0])), 'yyyy-MM-DD HH:mm:ss'),
          endTime: Utils.timeFormat(Number(Utils.endOfDay(this.date[1])), 'yyyy-MM-DD HH:mm:ss'),
          orderType: this.type,
        }
        this.loading = true
        this.reqNum++
        let {code,data} = await queryOpdDiagnosisRank(params)
        this.afterRes()
        if(code==200){
          this.diagnosisRankingList = data || []
        }
      },
      basicTablePageNoChange(val){
        this.basicMap.pageNum = val
        this.getList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .outpatientData {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left_radio /deep/ .el-radio-button__inner {
    padding: 0 28px;
    height: 36px;
    line-height: 34px;
  }

  .card {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }

  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card_header_icon {
    width: 26px;
    height: 26px;
  }

  .card_header_icon_img {
    width: 100%;
    height: 100%;
  }

  .card_header_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .card_header_icon+.card_header_title {
    margin: 0 0 0 10px;
  }

  .card_header_date {
    margin: 0 0 0 8px;
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .card_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .card_header_count {
    line-height: 24px;
    font-size: 16px;
    color: #000000;
  }

  .to_more {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
  }

  .to_more_text {
    font-size: 14px;
    color: #667182;
  }

  .to_more_icon {
    margin: 0 0 0 2px;
    font-size: 14px;
    color: #667182;
  }

  .custom_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
  }

  .custom_table::before {
    display: none;
  }

  .custom_table /deep/ .el-table__row:last-child td {
    border-bottom: none;
  }

  .basic {
    margin: 24px 0 0 0;
  }

  .basic_status_list {
    display: grid;
    grid-template-columns: 1fr auto 1fr 1fr 1fr auto 1fr 1fr;
    column-gap: 16px;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .status_list_item {
    box-sizing: border-box;
    position: relative;
    z-index: 1;
    padding: 16px 16px 0;
    height: 132px;
    background-color: #E8F4FF;
    border-radius: 8px;
    cursor: pointer;
  }

  .status_list_item.active {
    background: linear-gradient( 135deg, #39A0FF 0%, #0177E5 100%);
    box-shadow: 0px 2px 8px 0px rgba(0,29,57,0.2);
  }

  .status_list_item.active::after {
    content: '\25BC';
    position: absolute;
    z-index: 1;
    bottom: -10px;
    left: 50%;
    font-size: 12px;
    color: #1283ED;
    transform: translate(-50%, 0);
  }

  .status_list_line {
    width: 1px;
    height: 140px;
    background-color: #E0E0E0;
  }

  .status_title {
    line-height: 24px;
    font-weight: bold;
    font-size: 15px;
    color: #000000;
  }

  .status_list_item.active .status_title {
    color: #FFFFFF;
  }

  .status_info {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 12px;
    align-items: flex-start;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .status_info_left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .status_info_right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .status_info_line {
    margin: 34px 0 0 0;
    width: 1px;
    height: 22px;
    background-color: #E0E0E0;
  }

  .status_list_item.active .status_info_line {
    margin: 32px 0 0 0;
    height: 28px;
    background-color: rgba(219,222,226,0.5);
  }

  .status_info_title {
    line-height: 22px;
    font-size: 13px;
    color: #667182;
  }

  .status_list_item.active .status_info_title {
    color: rgba(255,255,255,0.8);
  }

  .status_info_num {
    margin: 2px 0 0 0;
    line-height: 30px;
    font-weight: bold;
    font-size: 22px;
    color: #000000;
  }

  .status_list_item.active .status_info_num {
    color: #FFFFFF;
  }

  .status_info_tips {
    line-height: 24px;
    text-align: right;
    font-size: 14px;
    color: #667182;
  }

  .status_list_item.active .status_info_tips {
    color: rgba(255,255,255,0.8);
  }

  .status_info_tips_num {
    margin: 0 2px;
    color: #000000;
  }

  .status_list_item.active .status_info_tips_num {
    color: #FFFFFF;
  }

  .basic_table_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0 0 0;
    width: 100%;
  }

  .basic_table_count {
    line-height: 24px;
    font-size: 16px;
    color: #667182;
  }

  .basic_table_count_num {
    margin: 0 2px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .basic_table_section {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .basic_table_price {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .basic_table_price_text {
    font-size: 14px;
    color: #1F2329;
  }

  .basic_table_price_tag {
    margin: 0 0 0 4px;
    font-size: 12px;
    color: #FE8F1F;
  }

  .basic_table_center {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .basic_table_tag {
    width: 40px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    font-size: 12px;
    color: #87919B;
    background-color: #F7F8F9;
  }

  .basic_table_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 16px 0 0 0;
    width: 100%;
  }
  .analyze {
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .analyze_info {
    flex-grow: 1;
    height: 350px;
  }

  .metric_list {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .metric_row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 16px;
    width: 100%;
  }

  .metric_row+.metric_row {
    margin: 16px 0 0 0;
  }

  .metric_item {
    box-sizing: border-box;
    padding: 0 16px;
    height: 120px;
    background-color: #F7F8F9;
    border-radius: 6px;
    overflow: hidden;
  }

  .metric_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 0 0;
    width: 100%;
  }

  .metric_label {
    line-height: 22px;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .metric_icon {
    width: 32px;
    height: 32px;
    overflow: hidden;
  }

  .metric_icon_img {
    width: 100%;
    height: 100%;
  }

  .metric_count {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    margin: 2px 0 0 0;
    width: 100%;
  }

  .metric_count_num {
    line-height: 30px;
    font-weight: bold;
    font-size: 24px;
    color: #000000;
  }

  .metric_count_unit {
    line-height: 24px;
    font-size: 14px;
    color: #000000;
  }

  .metric_tips {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .metric_tips_label {
    line-height: 24px;
    font-size: 14px;
    color: #667182;
  }

  .metric_tips_value {
    margin: 0 0 0 2px;
    line-height: 24px;
    font-weight: bold;
    font-size: 14px;
    color: #000000;
  }

  .diagnosis_ranking {
    flex-shrink: 0;
    box-sizing: border-box;
    margin: 0 0 0 16px;
    padding: 24px 16px 16px;
    width: 490px;
    height: 350px;
    background: linear-gradient( 315deg, #E1EEFF 0%, #C0E3FF 100%);
  }

  .ranking_list {
    margin: 16px 0 0 0;
    width: 100%;
    height: calc(100% - 28px - 16px);
  }

  .ranking_table {
    width: 100%;
    background: linear-gradient( 180deg, #F8FCFF 0%, #EEF7FE 100%);
    border-radius: 12px;
  }

  .ranking_table /deep/ tr {
    background-color: transparent;
  }
 
  .ranking_table /deep/ th.el-table__cell, .ranking_table /deep/ td.el-table__cell {
    background-color: transparent;
    border-bottom: none;
  }

  .ranking_table /deep/ th.el-table__cell>.cell {
    line-height: 20px;
    font-weight: 400;
    color: #667182;
  }

  .ranking_table /deep/ td.el-table__cell>.cell {
    line-height: 20px;
    font-weight: 400;
    color: #000000;
  }

  .ranking_table_index {
    font-weight: bold;
    font-size: 16px;
    color: #8F97A4;
  }

  .ranking_table_index_1 {
    color: #F54A45;
  }

  .ranking_table_index_2 {
    color: #FE8F1F;
  }

  .ranking_table_index_3 {
    color: #FFC900;
  }

  .ranking_table_name {
    min-width: 0;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>